import { environment } from "../environment";
import { AsyncResult } from "../models/common/async-result";
import { ForumTopic } from "../models/forumTopic";
import api from "./api";

export async function getForumTopics(forumId: number, clubId: number, wasApproved : '' | '0' | '1' = ''): Promise<ForumTopic[]> {
  const baseUrl = environment.api.forumTopic.getByClubAndForumId
    .replace('{clubId}', String(clubId))
    .replace('{forumId}', String(forumId))
    .replace('{wasApproved}', String(wasApproved));
  
  return await api.get(baseUrl).then(res => res.data.success);
}

export async function getForumTopicById(forumTopicId: number, forumId: number, clubId: number): Promise<ForumTopic> {
  const baseUrl = environment.api.forumTopic.getById
    .replace('{clubId}', String(clubId))
    .replace('{forumId}', String(forumId))
    .replace('{forumTopicId}', String(forumTopicId));
  
  return await api.get(baseUrl).then(res => res.data.success);
}

export async function approveTopic(clubId: number, forumId: number, forumTopicId: number): Promise<ForumTopic> {
  const baseUrl = environment.api.forumTopic.approve
    .replace('{clubId}', String(clubId))
    .replace('{forumId}', String(forumId))
    .replace('{forumTopicId}', String(forumTopicId));
  
  return await api.get(baseUrl).then(res => res.data.success);
}

export async function createForumTopic(payload: ForumTopic, clubId: number, forumId: number, userId: number): Promise<AsyncResult<ForumTopic>> {
  let baseUrl = environment.api.forumTopic.create
    .replace('{clubId}', String(clubId))
    .replace('{forumId}', String(forumId))
    .replace('{userId}', String(userId));

  return await api.post(baseUrl, payload)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } });
}

